module.exports = __webpack_public_path__ + "static/img/right-bottom-row-3.28541df2.webp";